import Dropdown from 'components/form/Dropdown'
import TextEditor from 'components/form/TextEditor'
import TextInput from 'components/form/TextInput'
import Card from 'components/Layout/Card'
import React from 'react'
import { eventMode } from 'utils/constants'
import CreatableDropdown from 'components/form/CreatableDropdown';
import { union, unionBy } from 'lodash'
import { titleCaseString } from 'utils/helpers'


const PaperDetails = ({ values, errors, handleChange, keywordsList, setKeywordsList }) => {
  return (
    <div className='cmb-16'>
      <Card className="cp-20">
        <div className="text-16-500 color-1717 cmb-20">Paper Details</div>
        <div className="border-bottom cmb-20 color-d1d1"></div>


        <div className="row">
          <div className=" cmb-24">
            <TextInput
              label="Paper Title*"
              value={values?.paper_title}
              error={errors?.paper_title}
              onChange={handleChange}
              id="paper_title"
              placeholder="Enter paper title"
            />
          </div>
          <div className=" cmb-24">
            <TextEditor
              label="Abstract*"
              id="paper_abstract"
              value={values?.paper_abstract}
              error={errors?.paper_abstract}
              onChange={handleChange}
              placeholder="Enter paper_abstract"
            />
          </div>
        </div>
        <div className='row '>
          <div className=" cmb-24 col-md-4">
            <CreatableDropdown
              label="Keywords"
              id="paper_keywords"
              options={unionBy(
                [
                  ...keywordsList?.existing,
                  ...keywordsList?.custom,
                ],
                'id'
              )}
              placeholder="Enter Keywords"
              value={values?.paper_keywords}
              error={errors?.paper_keywords}
              onChange={handleChange}
              onCreateOption={(e) => {
                let newCreate = [];
                if (e?.includes(',')) {
                  newCreate = e?.split(',');
                } else {
                  newCreate = [e];
                }
                newCreate = newCreate?.map((o) => {
                  let removedSpace = o?.trim();
                  return titleCaseString(removedSpace);
                });
                let strToArray = values?.paper_keywords
                  ? values?.paper_keywords?.split(',')
                  : [];
                strToArray = union([...strToArray, ...newCreate]);
                setKeywordsList({
                  ...keywordsList,
                  custom: [
                    ...keywordsList?.custom,
                    ...newCreate?.map((e) => {
                      return { id: e, label: e };
                    }),
                  ],
                });
                handleChange({
                  target: {
                    id: 'paper_keywords',
                    value: strToArray.join(','),
                  },
                });
              }}
            />
          </div>
          <div className="cmb-24 col-md-4">
            <Dropdown
              label="Presentation Type*"
              id="presentation_type"
              placeholder="Select"
              options={eventMode}
              optionKey="value"
              optionValue="value"
              onChange={handleChange}
              value={values?.presentation_type}
              error={errors?.presentation_type}
            />
          </div>
          <div className="col-md-4">
            <Dropdown
              label="How did you know about this conference?"
              id="source"
              placeholder="Select"
              options={[{ value: "LinkedIn" },
              {
                value: "Conference Alerts"
              },
              { value: "Email" },
              { value: "Google Search" },
              { value: "Google Advertisement" },
              { value: "Referred by Organizing Committee Member" },
              { value: "Social Media" },
              { value: "Through the University/ Institue or College" },
              { value: "Friend" },
              { value: "Other" },
              ]}
              optionKey="value"
              optionValue="value"
              onChange={handleChange}
              value={values?.source}
              error={errors?.source}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PaperDetails
